const defaultState = {
  competitions: null,
  requiredCredentials: null,
}

export default defaultState
